import useTenant from '@/hooks/useTenant'

import { TFunction } from 'i18next'

const useAllergenInfoText = (t: TFunction) => {
  const tenant = useTenant()
  if (tenant.id === '66ab5c5872a12355ff1f968a') return ''

  return t('marketplace:allergentInfoText', { tenantName: tenant.name })
}

export default useAllergenInfoText
